var _defs, _path, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityReportsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5d6a76;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.45,21.83H5.55a3.38,3.38,0,0,1-3.38-3.38V5.55A3.38,3.38,0,0,1,5.55,2.17h12.9a3.38,3.38,0,0,1,3.38,3.38v12.9A3.38,3.38,0,0,1,18.45,21.83ZM5.55,3.67A1.88,1.88,0,0,0,3.67,5.55v12.9a1.88,1.88,0,0,0,1.88,1.88h12.9a1.88,1.88,0,0,0,1.88-1.88V5.55a1.88,1.88,0,0,0-1.88-1.88Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.21 15.73 5.07 14.76 8.84 10.34 12.98 13.47 17.34 7.66 18.54 8.56 13.28 15.58 9.06 12.39 6.21 15.73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityReportsIcon);
export default __webpack_public_path__ + "static/media/activity_reports_icon.b7500842966907d8e7f5cff76d9cfa9c.svg";
export { ForwardRef as ReactComponent };